/*تبلیغات*/
import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={84.374}
      height={84.374}
      viewBox="0 0 84.374 84.374"
      {...props}
    >
      <g data-name="Group 625" transform="translate(1.361 1.361)">
        <path
          data-name="Path 11198"
          d="M0 10.887h81.653v48.992H0z"
          fill="#e0e0e2"
        />
        <g data-name="Group 624" fill="#ff9811">
          <path data-name="Path 11199" d="M34.022 0h13.609v5.444H34.022z" />
          <path data-name="Path 11200" d="M6.804 0h13.609v5.444H6.804z" />
          <path data-name="Path 11201" d="M61.239 0h13.609v5.444H61.239z" />
          <path
            data-name="Path 11202"
            d="M13.608 65.322h54.435v4.083H13.608z"
          />
        </g>
        <path
          data-name="Path 11203"
          d="M35.383 59.879H46.27v5.443H35.383z"
          fill="#787680"
        />
        <path
          data-name="Path 11204"
          d="M35.383 69.405H46.27v12.248H35.383z"
          fill="#787680"
        />
        <path
          data-name="Path 11205"
          d="M40.827 20.413v16.33l-8.165-8.165-13.609 13.609-5.444-5.444-8.165 8.17v-24.5z"
          fill="#78b9eb"
        />
        <ellipse
          data-name="Ellipse 590"
          cx={2.967}
          cy={4.945}
          rx={2.967}
          ry={4.945}
          transform="translate(9.905 22.374)"
          fill="#ffda44"
        />
        <path
          data-name="Path 11206"
          d="M27.218 50.353H5.444v-5.444l8.165-8.165z"
          fill="#4e901e"
        />
        <path
          data-name="Path 11207"
          d="M40.826 36.743v13.609H27.217l-8.165-8.165 13.609-13.609z"
          fill="#91cc04"
        />
        <path
          data-name="Path 11208"
          d="M46.27 20.413h29.939v9.526H46.27z"
          fill="#ffda44"
        />
      </g>
      <g data-name="Group 626">
        <path
          data-name="Path 11209"
          d="M83.014 10.887H70.766V8.165h5.444A1.361 1.361 0 0077.57 6.8V1.361A1.361 1.361 0 0076.209 0H62.6a1.361 1.361 0 00-1.361 1.361V6.8A1.361 1.361 0 0062.6 8.165h5.444v2.722h-24.5V8.165h5.444A1.361 1.361 0 0050.352 6.8V1.361A1.361 1.361 0 0048.992 0H35.383a1.361 1.361 0 00-1.361 1.361V6.8a1.361 1.361 0 001.361 1.361h5.444v2.722h-24.5V8.165h5.444A1.361 1.361 0 0023.135 6.8V1.361A1.361 1.361 0 0021.774 0H8.165A1.361 1.361 0 006.8 1.361V6.8a1.361 1.361 0 001.361 1.361h5.444v2.722H1.361A1.361 1.361 0 000 12.248v48.991A1.361 1.361 0 001.361 62.6h34.022v2.722H14.97a1.361 1.361 0 00-1.361 1.361v4.083a1.361 1.361 0 001.361 1.361h20.413v10.887a1.361 1.361 0 001.361 1.361h10.887a1.361 1.361 0 001.361-1.361V72.126H69.4a1.361 1.361 0 001.361-1.361v-4.082a1.361 1.361 0 00-1.361-1.361H48.992V62.6h34.022a1.361 1.361 0 001.361-1.361V12.248a1.361 1.361 0 00-1.361-1.361zM63.961 5.444V2.722h10.887v2.722zm-27.218 0V2.722h10.888v2.722zm-27.218 0V2.722h10.888v2.722zM46.27 81.653H38.1v-9.527h8.17zm21.774-13.609V69.4H16.331v-1.356zM38.1 65.322V62.6h8.17v2.722zm43.548-5.444H2.722V13.609h78.931z"
        />
        <path
          data-name="Path 11210"
          d="M14.969 35.383a5.443 5.443 0 10-5.443-5.444 5.443 5.443 0 005.443 5.444zm0-8.165a2.722 2.722 0 11-2.722 2.722 2.722 2.722 0 012.722-2.722z"
        />
        <path
          data-name="Path 11211"
          d="M42.188 20.413H6.805a1.361 1.361 0 00-1.361 1.361v29.939a1.361 1.361 0 001.361 1.361h35.383a1.361 1.361 0 001.356-1.361V21.774a1.361 1.361 0 00-1.356-1.361zM8.166 50.352v-3.52l6.8-6.8 4.481 4.481 5.842 5.842zm32.661 0H29.144l-6.8-6.8 11.678-11.689 6.8 6.8zm0-15.533l-5.842-5.843a1.363 1.363 0 00-1.926 0L20.414 41.624l-4.481-4.482a1.364 1.364 0 00-1.926 0l-5.842 5.843v-19.85h32.662z"
        />
        <path
          data-name="Path 11212"
          d="M72.127 34.022h-24.5a1.361 1.361 0 000 2.722h24.5a1.361 1.361 0 100-2.722z"
        />
        <path
          data-name="Path 11213"
          d="M77.57 34.022h-1.361a1.361 1.361 0 000 2.722h1.361a1.361 1.361 0 000-2.722z"
        />
        <path
          data-name="Path 11214"
          d="M72.127 39.465h-24.5a1.361 1.361 0 000 2.722h24.5a1.361 1.361 0 100-2.722z"
        />
        <path
          data-name="Path 11215"
          d="M77.57 39.465h-1.361a1.361 1.361 0 000 2.722h1.361a1.361 1.361 0 000-2.722z"
        />
        <path
          data-name="Path 11216"
          d="M72.127 44.909h-24.5a1.361 1.361 0 000 2.722h24.5a1.361 1.361 0 100-2.722z"
        />
        <path
          data-name="Path 11217"
          d="M77.57 44.909h-1.361a1.361 1.361 0 000 2.722h1.361a1.361 1.361 0 000-2.722z"
        />
        <path
          data-name="Path 11218"
          d="M72.127 50.352h-24.5a1.361 1.361 0 000 2.722h24.5a1.361 1.361 0 100-2.722z"
        />
        <path
          data-name="Path 11219"
          d="M77.57 50.352h-1.361a1.361 1.361 0 000 2.722h1.361a1.361 1.361 0 000-2.722z"
        />
        <path
          data-name="Path 11220"
          d="M46.27 21.774V31.3a1.361 1.361 0 001.361 1.361H77.57a1.361 1.361 0 001.361-1.361v-9.526a1.361 1.361 0 00-1.361-1.361H47.631a1.361 1.361 0 00-1.361 1.361zm2.722 1.361H76.21v6.8H48.992z"
        />
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
